<main class="app" [class.dark]="isDarkTheme()">
  <router-outlet></router-outlet>
</main>
